import { render, staticRenderFns } from "./BirthPlaceField.vue?vue&type=template&id=53979161&scoped=true&"
import script from "./BirthPlaceField.vue?vue&type=script&lang=js&"
export * from "./BirthPlaceField.vue?vue&type=script&lang=js&"
import style0 from "./BirthPlaceField.vue?vue&type=style&index=0&id=53979161&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53979161",
  null
  
)

export default component.exports